export enum PatientRedirectTypeEnum {
    evasao = 1,
    retorno_a_fila = 2,
}